/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BuyoutRights { 
    licenseRegion: string;
    channel?: string;
    buyoutType?: string;
    expiryDate?: string;
    noExpiry?: boolean;
}

